import { ComponentType } from "react";

import DirectApplyClientDetailPage from "../../../direct-apply/pages/DirectApplyClientDetailPage";
import { ModuleName } from "../../utils/module-name";
import CampaignsClientDetailPage from "../campaigns/pages/CampaignsClientDetailPage";
import ChatTenantDetailPage from "../chat/pages/ChatTenantDetailPage";
import JobSourceClientDetailPage from "../job-source/pages/JobSourceClientDetailPage";
import JobSourceTenantDetailPage from "../job-source/pages/JobSourceTenantDetailPage";
import JobSyncClientDetailPage from "../job-sync/pages/JobSyncClientDetailPage";
import OrganicJobDeliveryClientDetailPage from "../organic-job-delivery/pages/OrganicJobDeliveryClientDetailPage";
import TenantModuleDetailPage from "../pages/TenantModuleDetailPage";
import ClientReportingPage from "../reporting/pages/ClientReportingPage";
import TenantReportingPage from "../reporting/pages/TenantReportingPage";

type ModulePages = {
  client: ComponentType | null;
  tenant: ComponentType | null;
};

const moduleDetailPages: Partial<Record<ModuleName, ModulePages>> = {
  [ModuleName.Reporting]: {
    client: ClientReportingPage,
    tenant: TenantReportingPage,
  },
  [ModuleName.JobSource]: {
    client: JobSourceClientDetailPage,
    tenant: JobSourceTenantDetailPage,
  },
  [ModuleName.Organic]: {
    client: OrganicJobDeliveryClientDetailPage,
    tenant: TenantModuleDetailPage,
  },
  [ModuleName.Campaigns]: {
    client: CampaignsClientDetailPage,
    tenant: TenantModuleDetailPage,
  },
  [ModuleName.Chat]: {
    client: null,
    tenant: ChatTenantDetailPage,
  },
};

/**
 * Module-specific overrides for client-level pages (bespoke pages that don't use the
 * generic schema shell).
 */
const clientPageOverrides: Partial<Record<ModuleName, ComponentType>> = {
  [ModuleName.JobSync]: JobSyncClientDetailPage,
  [ModuleName.DirectApply]: DirectApplyClientDetailPage,
};

export const getModuleDetailPage = (
  moduleName: ModuleName,
  clientContext: boolean = false,
) => {
  const pages = moduleDetailPages[moduleName];

  if (clientContext) {
    // null signals "no dedicated client page" — the caller redirects to the client
    // integration overview rather than rendering a blank page.
    const ClientComponent =
      clientPageOverrides[moduleName] ?? pages?.client ?? null;
    return ClientComponent ? <ClientComponent /> : null;
  }

  // Tenant level: use module-specific page if available, otherwise the default
  const TenantComponent = pages?.tenant ?? TenantModuleDetailPage;
  return <TenantComponent />;
};
